/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import platform from 'platform';

export interface Version {
  major: number;
  minor: number;
}

export const isIE: boolean = platform.name === 'IE';
export const isChrome: boolean = platform.name === 'Chrome';
export const isSafari: boolean = platform.name === 'Safari';
export const isFirefox: boolean = platform.name === 'Firefox';
export const browserVersion: number = parseInt(platform.version || '', 10);

const platformFamilyContains = (queryString: string): boolean => {
  return (platform.os &&
    platform.os.family &&
    platform.os.family.indexOf(queryString) !== -1) as boolean;
};

const platformFamilyDoesNotContain = (queryString: string): boolean => {
  return !platformFamilyContains(queryString);
};

const hasTouchEvents = (): boolean => {
  return 'ontouchstart' in window;
};

export const isMac: boolean =
  platformFamilyContains('OS X') && !hasTouchEvents();

export const isWindows: boolean =
  platformFamilyContains('Windows') &&
  platformFamilyDoesNotContain('Windows Phone');

export const isMobile: boolean =
  platformFamilyContains('Android') ||
  platformFamilyContains('iOS') ||
  (platformFamilyContains('OS X') && hasTouchEvents());

export const isAndroid: boolean = platformFamilyContains('Android');
export const isIos: boolean = platformFamilyContains('iOS');

const platformRawVersion: string = (platform.os && platform.os.version) || '';
export const platformVersion: Version = {
  major: parseInt(platformRawVersion.split('.')[0], 10),
  minor: parseInt(platformRawVersion.split('.')[1], 10),
};
